import React from 'react';
import { ButtonBase, Grid, makeStyles, Typography } from '@material-ui/core';
import { classNames } from '../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    // [theme.breakpoints.only('md')]: {
    //   width: '20%',
    // },
    // [theme.breakpoints.only('sm')]: {
    //   width: '50%',
    // },
    // [theme.breakpoints.only('xs')]: {
    //   width: '100%',
    // },
  },
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
    marginBottom: '1rem',
    fontWeight: '500',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: ({ padding }) => ({
    width: '1.875rem',
    height: '1.875rem',
    color: '#ffffff',
    padding,
    marginRight: '0.938rem',
    borderRadius: '0.312rem',
  }),
  text: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.875rem',
    fontWeight: 'bold',
    color: '#2e4469',
    lineHeight: '1.875rem',
  },
}));

export default function ColumnItem({
  title,
  IconCom,
  text,
  iconBgColor,
  className,
  style,
  onClick,
  xs = 'auto',
  sm = 'auto',
  md = 'auto',
  lg = 'auto',
  xl = 'auto',
  id,
  DischgIcon,
  dischgIconColor,
  dischgCountText,
  pendingFYA,
  padding = '0.25rem',
}) {
  const classes = useStyles({ padding });
  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
      <ButtonBase
        id={id}
        className={classNames(classes.root, className)}
        style={style}
        disabled={!onClick}
        onClick={onClick}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            minWidth: 'auto',
            padding: '1.5rem 2rem 1.5rem 2rem',
          }}
        >
          <Typography className={classes.title}>{title}</Typography>
          <div
            style={{
              display: 'flex',
            }}
          >
            <div className={classes.box}>
              <IconCom className={classes.icon} style={{ background: iconBgColor }} />
              <Typography className={classes.text}>{text}</Typography>
            </div>
            {DischgIcon && (
              <div className={classes.box} style={{ marginLeft: '1.5rem' }}>
                <DischgIcon className={classes.icon} style={{ background: dischgIconColor }} />
                <Typography className={classes.text}>{dischgCountText}</Typography>
              </div>
            )}
          </div>
        </div>
      </ButtonBase>
    </Grid>
  );
}
